export const values = {
  datatype: null,
  tv: null,
  assetclass: null,
  subassetclass: null,
  instrument: null,
  instrumentmic: null,
  ordertype: null
};

export const funcs = {
  onChangeFieldValue(name, value, values) {
    const clearValuesMap = {
      datatype: [ 'tv', 'assetclass', 'subassetclass', 'instrument', 'instrumentmic', 'ordertype' ],
      tv: [ 'assetclass', 'subassetclass', 'instrument', 'instrumentmic', 'ordertype' ],
      assetclass: [ 'subassetclass', 'instrument', 'instrumentmic', 'ordertype' ],
      subassetclass: [ 'instrument', 'instrumentmic', 'ordertype' ],
      instrument: [ 'instrumentmic', 'ordertype' ],
      instrumentmic: [ 'ordertype' ],
      ordertype: []
    };
    clearValuesMap[name].forEach((val) => (values[val] = null));
    values[name] = value;
  },

  setFieldValidity(fieldName, fieldValidity) {
    if (fieldName === 'instrument') {
      fieldValidity.set('ordertype', true);
      fieldValidity.set('instrumentmic', true);
    }
  },

  validateSync(values, errors) {
    return (
      values.datatype !== null &&
      values.tv !== null &&
      values.assetclass !== null &&
      values.subassetclass !== null &&
      values.instrument !== null
    );
  }
};



// WEBPACK FOOTER //
// ./src/containers/DataSelect/dataSelectFormData.js